import { h } from 'vue'
import { Avatar, Tooltip } from 'ant-design-vue'
export function createAvatar({ label = '', src = '', size = 30, backgroundColor = '#f56a00'} = {}) {
  return h(
    Avatar,
    {
      size,
      src,
      class: 'pointer',
      style: {
        backgroundColor: src ? 'transparent' : backgroundColor
      }
    },
    () => {
      if (label.length == 1 && label.length > 4) {
        return label
      } else if (label.length == 2) {
        return label[1]
      } else {
        return label.slice(-2)
      }
    }
  )
}
export function createToolTip({ label = '-', ...props } = {}) {
  return h(
    Tooltip,
    {
      ...props
    },
    () => label
  )
}
